import * as XLSX from 'xlsx';
import FileSaver from 'file-saver'
import {
  Message,
} from 'element-ui'
const utils = {
  stringToHex(Str) {
    // 转数组，循环数组操作
    let str = Str.split('');
    let val = "";
    for (let i = 0; i < str.length; i++) {
      if (val == "") {
        // 转16进制.
        val = Str.charCodeAt(i).toString(16);
        // 字符串倒序
        val = this.reverseOrder(val);
      }
      else {
        // 转16进制.
        let newVal = Str.charCodeAt(i).toString(16);
        // 字符串倒序
        val += this.reverseOrder(newVal);
      }
    }
    return val;
  },
  // 字符串倒序方法
  reverseOrder(str) {
    // 先分解成数组,数组倒序,最后转成字符串
    let newStr = str.split('').reverse().join('');
    return newStr

  },
  // 转换数组里的字段
  changeArrayParam(array) {
    let arr = JSON.parse(JSON.stringify(array).replace(/name/g, 'label'));
    return JSON.parse(JSON.stringify(arr).replace(/id/g, 'value'));
  },

  // 使对象所有值变空
  objNull(obj) {
    Object.keys(obj).forEach(key => { obj[key] = '' })
  },

  // 时间戳转时间
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
      }
    }
    return fmt;
  },

  padLeftZero(str) {
    return ('00' + str).substr(str.length);
  },

  // 现在的时间 当前，此刻
  nowTime() {
    let start = new Date();
    let time = this.formatDate(start, 'yyyy-MM-dd')
    return time
  },

  // 现在的时间 到秒
  nowTime2() {
    let start = new Date();
    let time = this.formatDate(start, 'yyyyMMddhhmmss')
    return time
  },

  // 一年后时间
  oneYearLater() {
    let start = new Date();
    let time = start.setTime(start.getTime() + 1000 * 60 * 60 * 24 * 365 * 1);
    let data = new Date(time);
    return this.formatDate(data, 'yyyy-MM-dd')
  },

  // 一周前
  lastWeekTime() {
    let date = new Date();
    // 七天前时间换算
    date.setDate(date.getDate() - 7);
    // 年
    let y = date.getFullYear()
    // 月
    let m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    // 日
    let d = date.getDate()

    let time = y + "-" + m + "-" + d
    return time

  },

  // 三年前的时间
  threeYearsTime() {
    let start = new Date();
    let time = start.setTime(start.getTime() - 1000 * 60 * 60 * 24 * 365 * 3);
    let data = new Date(time);
    return this.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
  },

  // 一个月前的时间
  oneMonthTime() {
    let start = new Date();
    let time = start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    let data = new Date(time);
    return this.formatDate(data, 'yyyy-MM-dd')
  },

  // 一年前的时间
  oneYearTime() {
    let start = new Date();
    let time = start.setTime(start.getTime() - 1000 * 60 * 60 * 24 * 365 * 1);
    let data = new Date(time);
    return this.formatDate(data, 'yyyy-MM-dd')
  },

  // 当月时间  获取当月第一天
  currentMonth() {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

    return this.formatDate(firstDayOfMonth, 'yyyy-MM-dd')

  },


  // 今年时间  获取今年第一天
  currentYear() {
    const today = new Date();
    const year = today.getFullYear();
    const firstDay = new Date(year + "-01-01");


    return this.formatDate(firstDay, 'yyyy-MM-dd')

  },



  // 订单状态判断
  O_Sort(res) {
    // console.log(res)
    let msg;
    if (res == 0) {
      msg = '询价'
    } else if (res == 1) {
      msg = '转订单'
    } else if (res == 2) {
      msg = '转单驳回'
    } else if (res == 3) {
      msg = '新增'
    } else if (res == 4) {
      msg = '提交'
    } else if (res == 5) {
      msg = '审核'
    } else if (res == 6) {
      msg = '生效'
    } else if (res == 7) {
      msg = '付款'
    } else if (res == 8) {
      msg = '执行'
    } else if (res == 9) {
      msg = '运输'
    } else if (res == 10) {
      msg = '交付'
    } else if (res == 11) {
      msg = '出货通知'
    } else if (res == 12) {
      msg = '出库中'
    } else if (res == 13) {
      msg = '出库'
    } else if (res == 20) {
      msg = '完成'
    } else if (res == 24) {
      msg = '结束'
    } else if (res == 25) {
      msg = '服务'
    } else if (res == 41) {
      msg = '暂停'
    } else if (res == 42) {
      msg = '挂起'
    } else if (res == 90) {
      msg = '存档'
    } else if (res == 44) {
      msg = '冻结'
    } else if (res == -4) {
      msg = '作废'
    } else if (res == -1) {
      msg = '删除'
    } else if (res == 99) {
      msg = '全部'
    }

    return msg
  },


  // 判断订单类型
  orderType(type) {
    let sType;
    if (type == '销售订单') {
      sType = 1
    } else if (type == '采购订单') {
      sType = 2
    } else if (type == '销售询价') {
      sType = 3
    } else if (type == '采购需求') {
      sType = 4
    }
    return sType
  },


  // 导出1
  exportFile(name) {
    let tableDom = document.querySelector("#table").cloneNode(true);
    let tableHeader = tableDom.querySelector('.el-table__header-wrapper');
    let tableBody = tableDom.querySelector('.el-table__body');
    tableHeader.childNodes[0].append(tableBody.childNodes[1]);
    let headerDom = tableHeader.childNodes[0].querySelectorAll('th');
    let bodyDom = tableHeader.childNodes[0].querySelectorAll('td');
    // 移除左侧checkbox的节点
    if (headerDom[0].querySelectorAll('.el-checkbox').length > 0) {
      headerDom[0].remove();
    }

    for (let key in bodyDom) {
      if (bodyDom[key].innerText === '编辑 删除') {
        bodyDom[key].remove();
      }
    }
    for (let key in headerDom) {
      if (headerDom[key].innerText === '操作') {
        headerDom[key].remove();
      }
    }
    // 清理掉checkbox 和操作的button
    let tableList = tableHeader.childNodes[0].childNodes[2].querySelectorAll('td');
    for (let key = 0; key < tableList.length; key++) {
      if (tableList[key].querySelectorAll('.el-checkbox').length > 0 || tableList[key].querySelectorAll('.el-button').length > 0) {
        tableList[key].remove();
      }
    }
    // // 获取web的节点
    let webBook = XLSX.utils.table_to_book(tableHeader);
    // 把当前的book节点写入XLSX中
    let webOut = XLSX.write(webBook, { bookType: 'xlsx', bookSST: true, type: 'array' });
    try {
      Message({
        message: '正在下载!',
        type: 'success'
      });
      FileSaver.saveAs(new Blob([webOut], { type: 'application/octet-stream' }), name + '.xlsx');
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, webOut)
    }
    return webOut

  },


  // 导出2
  exportFile2(name) {
    let tableDom = document.querySelector("#table2").cloneNode(true);
    let tableHeader = tableDom.querySelector('.el-table__header-wrapper');
    let tableBody = tableDom.querySelector('.el-table__body');
    tableHeader.childNodes[0].append(tableBody.childNodes[1]);
    let headerDom = tableHeader.childNodes[0].querySelectorAll('th');
    let bodyDom = tableHeader.childNodes[0].querySelectorAll('td');
    // 移除左侧checkbox的节点
    if (headerDom[0].querySelectorAll('.el-checkbox').length > 0) {
      headerDom[0].remove();
    }

    for (let key in bodyDom) {
      if (bodyDom[key].innerText === '编辑 删除') {
        bodyDom[key].remove();
      }
    }
    for (let key in headerDom) {
      if (headerDom[key].innerText === '操作') {
        headerDom[key].remove();
      }
    }
    // 清理掉checkbox 和操作的button
    let tableList = tableHeader.childNodes[0].childNodes[2].querySelectorAll('td');
    for (let key = 0; key < tableList.length; key++) {
      if (tableList[key].querySelectorAll('.el-checkbox').length > 0 || tableList[key].querySelectorAll('.el-button').length > 0) {
        tableList[key].remove();
      }
    }
    // // 获取web的节点
    let webBook = XLSX.utils.table_to_book(tableHeader);
    // 把当前的book节点写入XLSX中
    let webOut = XLSX.write(webBook, { bookType: 'xlsx', bookSST: true, type: 'array' });
    try {
      Message({
        message: '正在下载!',
        type: 'success'
      });
      FileSaver.saveAs(new Blob([webOut], { type: 'application/octet-stream' }), name + '.xlsx');
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, webOut)
    }
    return webOut

  },



  // 导出2 两个表格导出
  exportMultipleSheets(name) {
    // 创建工作簿
    const wb = XLSX.utils.book_new();
    // 第一个表格 获取数据
    let tableDom = document.querySelector("#table").cloneNode(true);
    let tableHeader = tableDom.querySelector('.el-table__header-wrapper');
    let tableBody = tableDom.querySelector('.el-table__body');
    tableHeader.childNodes[0].append(tableBody.childNodes[1]);
    let headerDom = tableHeader.childNodes[0].querySelectorAll('th');
    let bodyDom = tableHeader.childNodes[0].querySelectorAll('td');

    // 移除左侧checkbox的节点
    if (headerDom[0].querySelectorAll('.el-checkbox').length > 0) {
      headerDom[0].remove();
    }

    for (let key in bodyDom) {
      if (bodyDom[key].innerText === '编辑 删除') {
        bodyDom[key].remove();
      }
    }
    for (let key in headerDom) {
      if (headerDom[key].innerText === '操作') {
        headerDom[key].remove();
      }
    }
    // 清理掉checkbox 和操作的button
    let tableList = tableHeader.childNodes[0].childNodes[2].querySelectorAll('td');
    for (let key = 0; key < tableList.length; key++) {
      if (tableList[key].querySelectorAll('.el-checkbox').length > 0 || tableList[key].querySelectorAll('.el-button').length > 0) {
        tableList[key].remove();
      }
    }


    // 第二个表格********************************************************************************************************************************
    let tableDom2 = document.querySelector("#table2").cloneNode(true);
    let tableHeader2 = tableDom2.querySelector('.el-table__header-wrapper');
    let tableBody2 = tableDom2.querySelector('.el-table__body');
    tableHeader2.childNodes[0].append(tableBody2.childNodes[1]);
    let headerDom2 = tableHeader2.childNodes[0].querySelectorAll('th');
    let bodyDom2 = tableHeader2.childNodes[0].querySelectorAll('td');


    // 移除左侧checkbox的节点
    if (headerDom2[0].querySelectorAll('.el-checkbox').length > 0) {
      headerDom2[0].remove();
    }

    for (let key in bodyDom2) {
      if (bodyDom2[key].innerText === '编辑 删除') {
        bodyDom2[key].remove();
      }
    }
    for (let key in headerDom2) {
      if (headerDom2[key].innerText === '操作') {
        headerDom2[key].remove();
      }
    }


    // 清理掉checkbox 和操作的button
    let tableList2 = tableHeader2.childNodes[0].childNodes[2].querySelectorAll('td');
    for (let key = 0; key < tableList2.length; key++) {
      if (tableList2[key].querySelectorAll('.el-checkbox').length > 0 || tableList2[key].querySelectorAll('.el-button').length > 0) {
        tableList2[key].remove();
      }
    }
    // /整合在一起
    let webBook = XLSX.utils.table_to_book(tableHeader);
    let webBook2 = XLSX.utils.table_to_book(tableHeader2);

    XLSX.utils.book_append_sheet(wb, webBook.Sheets.Sheet1, "Sheet1");
    XLSX.utils.book_append_sheet(wb, webBook2.Sheets.Sheet1, "Sheet2");

    // 导出Excel文件
    XLSX.writeFile(wb, name + ".xlsx");
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/api/utils.js